import { render, staticRenderFns } from "./IssueArea.vue?vue&type=template&id=9604f194&scoped=true&"
import script from "./IssueArea.vue?vue&type=script&lang=js&"
export * from "./IssueArea.vue?vue&type=script&lang=js&"
import style0 from "./IssueArea.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IssueArea.vue?vue&type=style&index=1&id=9604f194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9604f194",
  null
  
)

export default component.exports